import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { createLogger } from './logger';

// Create a logger instance
const logger = createLogger('initFA');

// Create a module-level variable to track initialization
let initialized = false;

/**
 * Initialize Font Awesome library with all necessary icons
 * This function is called when the module is imported
 */
function initializeFontAwesome() {
  if (initialized) return;

  library.add(fab, far, fas);

  initialized = true;
  logger.debug('Font Awesome initialized successfully', { fab, far, fas });
}

// Call the initialization function when module is imported
initializeFontAwesome();

// Export the initialization function to allow re-initialization if needed
export default initializeFontAwesome;
